import { FavoriteItemDto, TeamDto } from 'utils/api/dto';
import * as endpoints from 'utils/api/endpoints';
import { httpMethods, useFetchData } from 'utils/hooks/use-fetch-data';

export type UseFetchFavoritesParams = {
    initialCondition: boolean;
    /** FAV_AND_RECENT_TYPE_* */
    favType: string;
    /** also loads all the teams (endpoints.teams), to show the favorite ones */
    isAllTeams?: boolean;
    /** of the teams */
    enableCache?: boolean;
};

/** The favorite records of a type and, with isAllTeams, all the teams */
export const useFetchFavorites = ({
    initialCondition,
    favType,
    isAllTeams = false,
    enableCache = true
}: UseFetchFavoritesParams) => {
    const { data: favItems, processing: favProcessing } = useFetchData<FavoriteItemDto[]>({
        method: httpMethods.get,
        url: `${endpoints.favoriteItems}?itemType=${favType}`,
        initialCondition
    });

    const { data: allTeams, processing: teamProcessing } = useFetchData<TeamDto[]>({
        method: httpMethods.get,
        url: endpoints.teams,
        initialCondition: isAllTeams,
        enableCache
    });

    return { data: { favItems, allTeams }, processing: teamProcessing || favProcessing };
};
